import getParameterFromURL from '../utils/scripts/getParameterFromURL';

const initialState = {
  currentStep: null,
  previousStep: 'age',
  nextStep: null,
  currentStepIndex: null,
  totalSteps: null,
  currentStepCompleted: null,
  showActionBar: null,

  separationStepIndexes: [],
  hideHeaderStepIndexes: [],
  hideProgressStepIndexes: [],
  progressTitlesBySection: [],

  showStartSurveyScreen: getParameterFromURL('startSurveyScreen') && true,
  withoutMail: true, // getParameterFromURL('withoutMail') || true,
  design: {
    startSurveyScreen: getParameterFromURL('startSurveyScreen'),
  },
  config: getParameterFromURL('config') || 'customV2',
  puppyOnboarding: false,
};

function steps(state = initialState, action) {
  switch (action.type) {
    case 'SET_STEPS':
      return {
        ...state,
        list: action.payload,
        puppyOnboarding: state.config === 'customV45',
      };

    case 'STEP_GO_TO':
      return {
        ...state,
        currentStep: action.payload,
      };

    case 'SET_TOTAL_STEPS':
      return {
        ...state,
        totalSteps: action.payload,
      };

    case 'SET_CURRENT_INDEX':
      return {
        ...state,
        currentStepIndex: action.payload,
      };

    case 'SET_STEP_STATUS':
      return {
        ...state,
        list: action.payload,
      };

    case 'SET_PREVIOUS_STEP':
      return {
        ...state,
        previousStep: action.payload,
      };

    case 'SET_NEXT_STEP':
      return {
        ...state,
        nextStep: action.payload,
      };

    case 'SET_CURRENT_STEP_COMPLETED_STATUS':
      return {
        ...state,
        currentStepCompleted: action.payload,
      };

    case 'CHECK_ACTION_BAR_SHOWING':
      return {
        ...state,
        showActionBar: action.payload,
      };

    case 'SET_CURRENT_CONFIG':
      return {
        ...state,
        currentConfig: action.payload,
      };

    case 'TOGGLE_START_SURVEY_SCREEN':
      return {
        ...state,
        showStartSurveyScreen: action.payload,
      };

    case 'SKIP_MAIL_PRESSED':
      return {
        ...state,
        skipMailPressed: action.payload,
      };

    case 'SET_STEPS_META':
      return {
        ...state,
        separationStepIndexes: action.payload.separationStepIndexes,
        hideHeaderStepIndexes: action.payload.hideHeaderStepIndexes,
        hideProgressStepIndexes: action.payload.hideProgressStepIndexes,
        progressTitlesBySection: action.payload.progressTitlesBySection,
      };

    case 'SET_PUPPY_ONBOARDING':
      return {
        ...state,
        puppyOnboarding: action.payload,
      };

    default:
      return state;
  }
}

export default steps;
